import { render, staticRenderFns } from "./precadastro.vue?vue&type=template&id=e213c050&scoped=true&"
import script from "./precadastro.vue?vue&type=script&lang=js&"
export * from "./precadastro.vue?vue&type=script&lang=js&"
import style0 from "./precadastro.vue?vue&type=style&index=0&id=e213c050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e213c050",
  null
  
)

export default component.exports